import * as React from 'react';
import { sampleSubjectText, sampleLocationText } from './ColorPicker.locstring.json';
import loc from 'owa-localize';
import CalendarSurfaceItem from 'owa-calendar-surface-dategrid/lib/surfaceItems/CalendarSurfaceItem';
import CalendarSurfaceItem30OrUnder from 'owa-calendar-surface-dategrid/lib/surfaceItems/itemTemplates/CalendarSurfaceItem30OrUnder';
import type { CalendarSurfaceItemContentProps } from 'owa-calendar-surface-dategrid/lib/surfaceItems/itemTemplates/CalendarSurfaceItem.types';
import type { CalendarEvent } from 'owa-calendar-types';
import { generateColorScheme } from 'owa-color-utils/lib/colorUtils';
import { addMinutes, now, startOfHour } from 'owa-datetime';
import { observer } from 'mobx-react-lite';

import styles from './SampleCalendarEvent.scss';

export default observer(function SampleCalendarEvent({ color }: { color: string }) {
    const start = startOfHour(now());
    const sampleEvent: CalendarEvent = {
        FreeBusyType: 'Busy',
        ResponseType: 'Accept',
        End: addMinutes(start, 30),
        Start: start,
        Subject: loc(sampleSubjectText),
        Location: {
            DisplayName: loc(sampleLocationText),
        },
        IsAllDayEvent: false,
        IsCancelled: false,
    } as CalendarEvent;

    const colorScheme = generateColorScheme(color);

    return (
        <div className={styles.sampleCalendarItemWrapper}>
            <CalendarSurfaceItem
                className={styles.sampleCalendarItem}
                disableTabIndex={true}
                item={sampleEvent}
                colorScheme={colorScheme}
                title={null}
                onRender={onRender}
            />
        </div>
    );
});

function onRender(props: CalendarSurfaceItemContentProps) {
    return <CalendarSurfaceItem30OrUnder {...props} />;
}
